//#region types
import { UtilFormTypes } from "models/formTypes";
import { CostForwardingSource } from "models/utilTypes/costForwardingTypes";
import { saveMarkingBeforeDocument } from "./costForwardingMarkingModel";
//#endregion
//#region components
import { useCostForwardingService } from "serviceHooks";
//#endregion
import { EventHelper } from "utils/helpers";

// The footer that writes the marking and the to-do form that shows it are siblings, so the form
// learns about a successful write through this event.
export const getCostForwardingSavedEventName = (source: CostForwardingSource, sourceId: number) =>
  EventHelper.getDynamicEventName("costForwardingMarkingSaved", `${source}_${sourceId}`);

/**
 * Wraps a footer's document save so the to-do form's marking is written first; values from any other
 * form, such as the details form, write no marking.
 */
function useSaveCostForwardingMarking(source: CostForwardingSource) {
  const { putMarking } = useCostForwardingService();

  // A rejected marking rejects the footer action without saving the document. The shared error
  // interceptor has already shown the server's reason, and the to-do stays open to correct it.
  const saveWithCostForwardingMarking = <T,>(sourceId: number, values: object, saveDocument: () => Promise<T>) =>
    saveMarkingBeforeDocument(
      values as UtilFormTypes.CostForwardingMarking,
      (marking) => putMarking(source, sourceId, marking),
      saveDocument,
      (marking) => EventHelper.publishEvent(getCostForwardingSavedEventName(source, sourceId), marking)
    );

  return saveWithCostForwardingMarking;
}

export default useSaveCostForwardingMarking;
